<template>
  <div class="wrapper" id="pdf">
    <form class="contact-form" ref="form" @submit.prevent="save">
      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.nom") }}*</label>
            <md-input v-model="name" type="text" name="username"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.phone") }}*</label>
            <md-input
              @keypress="isNumberOnly"
              v-model="phone"
              type="text"
              name="phone"
            ></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.email") }}*</label>
            <md-input v-model="email" type="email" name="email"></md-input>
          </md-field>
        </div>

        <div class="md-layout-item md-size-50">
          <md-field>
            <label>{{ $t("landing.formulaire.nationalite") }}*</label>
            <md-input
              v-model="nationalite"
              type="text"
              name="nationalite"
            ></md-input>
          </md-field>
        </div>
      </div>

      <!--      <md-field maxlength="5">-->
      <!--        <label>{{ $t("landing.formulaire.message") }}*</label>-->
      <!--        <md-textarea v-model="message"></md-textarea>-->
      <!--      </md-field>-->

      <div class="rad md-layout">
        <div class="md-layout-item md-size-50">
          <label>Type d'assurance*</label>

          <br />
          <br />
          <md-radio v-model="assurance" value="Automobile">
            Automobile
          </md-radio>

          <br />
          <md-radio v-model="assurance" value="Voyage">
            Voyage
          </md-radio>
        </div>
      </div>

      <md-field v-if="assurance === 'Voyage'">
        <label>Date de départ prévue*</label>
        <md-input v-model="depart" type="text"></md-input>
      </md-field>

      <md-field>
        <label>Durée souhaitée*</label>
        <md-input v-model="dure" type="text"></md-input>
      </md-field>

      <md-field v-if="assurance === 'Voyage'">
        <label>Pays de destination*</label>
        <md-input v-model="pays" type="text"></md-input>
      </md-field>

      <md-field>
        <label>Autres informations</label>
        <md-input v-model="autreInfo" type="text"></md-input>
      </md-field>

      <div style="margin-top: 10px" v-if="assurance === 'Voyage'">
        <upload-template
          height="40px"
          background="#23B9E9"
          radius="100px"
          border="1px solid white"
          label="Cliquez ici pour ajouter une copie de votre pièce d'identité"
          @info="retourIdentite"
        />
      </div>

      <div style="margin-top: 10px" v-if="assurance === 'Voyage'">
        <upload-template
          height="40px"
          background="#FFBE33"
          radius="100px"
          border="1px solid white"
          label="Cliquez ici pour ajouter une copie de votre passport"
          @info="retourPassport"
        />
      </div>

      <div style="margin-top: 10px" v-if="assurance === 'Automobile'">
        <upload-template
          height="40px"
          background="#2AAB7A"
          radius="100px"
          border="1px solid gray"
          label="Cliquez ici pour ajouter la copie de votre permis de conduire"
          @info="retourPermis"
        />
      </div>

      <div style="margin-top: 10px" v-if="assurance === 'Automobile'">
        <upload-template
          height="40px"
          background="#2A90AB"
          radius="100px"
          border="1px solid gray"
          label="Cliquez ici pour ajouter la copie de votre carte grise"
          @info="retourGrise"
        />
      </div>

      <div style="margin-top: 10px" v-if="assurance === 'Automobile'">
        <upload-template
          height="40px"
          background="#F1603C"
          radius="100px"
          border="1px solid gray"
          label="Cliquez ici pour ajouter la copie d’une ancienne assurance datant d’au moins un an"
          @info="retourCopie"
        />
      </div>

      <div v-if="error" class="text-danger text-center alert-danger">
        {{ $t("echec") }}
      </div>

      <div
        v-if="success === true"
        class="text-success text-center alert-success"
      >
        {{ $t("success") }}
      </div>

      <div style="text-align: center">
        <pulse-loader
          :loading="loading"
          color="black"
          size="20px"
        ></pulse-loader>
      </div>

      <div class="md-layout" style="margin-top: 30px">
        <div class="md-layout-item md-size-33 mx-auto text-center">
          <md-button class="md-info" type="submit" value="Send">
            {{ $t("landing.formulaire.envoyer") }}
          </md-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import firebase from "firebase";
import { db } from "@/main";
import axios from "axios";
import uploadTemplate from "@/views/myComponents/uploadTemplate";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  bodyClass: "landing-page",

  components: {
    uploadTemplate,
    PulseLoader
  },

  data() {
    return {
      name: "",
      email: "",
      message: "Test",
      error: null,
      success: false,
      phone: "",
      nationalite: "",
      assurance: "",
      type: "",
      dure: "-",
      depart: "-",
      pays: "-",
      carte: null,
      copie: null,
      copieUrl: null,
      carteUrl: null,
      loading: false,
      passport: null,
      passportUrl: null,
      carteGrise: null,
      carteGriseUrl: null,
      permis: null,
      permisUrl: null,
      autreInfo: "-"
    };
  },

  methods: {
    isNumberOnly($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 42 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    retourIdentite(a) {
      this.carte = a;
    },
    retourCopie(a) {
      this.copie = a;
    },

    retourPassport(p) {
      this.passport = p;
    },

    retourPermis(p) {
      this.permis = p;
    },

    retourGrise(p) {
      this.carteGrise = p;
    },

    sendEmail(id) {
      const data = {
        service_id: "service_944rkdp",
        template_id: "template_fy382yi",
        user_id: "ScwOFQla9WLx6WNC_",
        template_params: {
          username: this.name,
          lien:
            "https://revelation-travel-4556e.web.app/#/pdfTok/assurance?id=" +
            id,
          email: this.email,
          phone: this.phone,
          nationalite: this.nationalite,
          procedure: "ASSURANCE",
          assurance: this.assurance,
          depart: this.depart,
          dure: this.dure,
          copie: this.copieUrl,
          piece: this.carteUrl,
          pays: this.pays,
          cartegrise: this.carteGriseUrl,
          permis: this.permisUrl,
          passport: this.passportUrl,
          autreInfo: this.autreInfo
        }
      };

      axios
        .post("https://api.emailjs.com/api/v1.0/email/send", data)
        .then(
          result => {
            console.log("SUCCESS!", result.text);
          },
          error => {
            console.log("FAILED...", error.text);
          }
        )
        .catch(error => {
          console.log(error);
        });
    },

    save() {
      if (
        this.name.length > 0 &&
        this.email.length > 0 &&
        this.nationalite.length > 0 &&
        this.phone.length > 0
      ) {
        this.error = null;
        this.loading = true;
        if (this.assurance === "Voyage") {
          this.saveImage("passport", this.passport);
          this.saveImage("carte", this.carte);
        } else {
          this.saveImage("permis", this.permis);
          this.saveImage("gris", this.carteGrise);
          this.saveImage("copie", this.copie);
        }
      } else {
        this.error = "error";
      }
    },

    finalSave() {
      let createdat = new Date().getTime();

      const document = db.collection("souscriptions").doc();

      document
        .set({
          id: document.id,
          name: this.name,
          email: this.email,
          nationalite: this.nationalite,
          procedure: "ASSURANCE",
          isRead: false,
          createdAt: createdat,
          phone: this.phone,
          type: this.assurance,
          depart: this.depart,
          dure: this.dure,
          carte: this.carteUrl,
          copieOldAssur: this.copieUrl,
          destination: this.pays,
          cartegrise: this.carteGriseUrl,
          permis: this.permisUrl,
          passport: this.passportUrl,
          autreInfo: this.autreInfo
        })
        .then(response => {
          this.success = true;
          console.log(response);
          this.sendEmail(document.id);
          this.loading = false;
        })
        .catch(error => {
          console.error("Error: ", error);
        });
    },

    saveImage(type, file) {
      firebase
        .storage()
        .ref("document/" + this.name + type)
        .put(file)
        .then(response => {
          response.ref.getDownloadURL().then(downloadURL => {
            if (type === "carte") {
              this.carteUrl = downloadURL;
            }

            if (type === "copie") {
              this.copieUrl = downloadURL;
            }

            if (type === "passport") {
              this.passportUrl = downloadURL;
            }

            if (type === "permis") {
              this.permisUrl = downloadURL;
            }

            if (type === "gris") {
              this.carteGriseUrl = downloadURL;
            }

            if (
              (this.carteGriseUrl && this.permisUrl && this.copieUrl) ||
              (this.carteUrl && this.passportUrl)
            ) {
              this.finalSave();
            }

            console.log(downloadURL);
          });
        })
        .catch(erreur => {
          console.log("Erreur:", erreur);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.md-success {
  margin-top: 3rem;
}
.hooper {
  height: auto;
}
.rad {
  margin-top: 30px;
}
.alert-success,
.alert-danger {
  margin-top: 50px;
}
</style>
